import apiClient from './apiClient';

export const taxReportService = {  /**
   * Generate tax report for specified filters
   * @param {Object} filters - The filters object containing year, quarter, etc.
   * @returns {Promise<Object>} Tax report data
   */
  generateTaxReport: async (filters) => {
    try {
      const response = await apiClient.get('/tax-reports/generate', {
        params: filters
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to generate tax report');
    }
  },
  /**
   * Export tax data in specified format
   * @param {Object} filters - The filters object containing year, quarter, etc.
   * @param {string} format - Export format ('csv', 'json')
   * @returns {Promise<Blob>} File data for download
   */
  exportTaxData: async (filters, format = 'csv') => {
    try {
      const response = await apiClient.get('/tax-reports/export', {
        params: { ...filters, format },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to export tax data');
    }
  },

  /**
   * Get tax planning insights and recommendations
   * @returns {Promise<Object>} Tax insights and recommendations
   */
  getTaxInsights: async () => {
    try {
      const response = await apiClient.get('/tax-reports/insights');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to get tax insights');
    }
  },

  /**
   * Generate and download tax report as PDF (if implemented)
   * @param {number} taxYear - The tax year
   * @param {string} reportType - Type of report ('schedule_c', 'quarterly', etc.)
   * @returns {Promise<Blob>} PDF file data
   */
  downloadTaxReportPDF: async (taxYear, reportType = 'schedule_c') => {
    try {
      const response = await apiClient.get('/tax-reports/pdf', {
        params: { taxYear, reportType },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to generate PDF report');
    }
  }
};
